import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './CheckSoft.module.less';
import { getLenovoSoft, setLenovoSoft } from '../../../actions/forum';
import Toast from '../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectLenovoSoft = createSelector(
  state => state.forum,
  forum => forum.forumLenovoSoft,
);

export default props => {
  const dispatch = useDispatch();
  const { setCheckSoftList, checkSoftList, pageKey, updateCheckSoft } = props;
  const logInfoData = useSelector(selectLogInfo);
  const lenovoSoft = useSelector(selectLenovoSoft);

  const [value, setValue] = useState('');
  const [changeIndex, setChangeIndex] = useState(null);
  const [checkSofts, setCheckSofts] = useState(checkSoftList || []);

  useEffect(() => {
    // 为了处理提交之后，输入框中的内容不清空问题
    if (updateCheckSoft) {
      setValue('');
      dispatch(setLenovoSoft({ word: '', pageKey, data: {} }));
    }
  }, [updateCheckSoft]);

  useEffect(() => {
    setCheckSofts(checkSoftList);
  }, [checkSoftList]);

  useEffect(() => {
    if (setCheckSoftList) {
      setCheckSoftList(checkSofts);
    }
  }, [checkSofts]);

  const handleChange = useCallback(
    ev => {
      ev.persist();
      const inputValue = ev.target.value.trim();
      setValue(inputValue);
      if (inputValue) {
        dispatch(getLenovoSoft({ word: inputValue, pageKey }));
      } else {
        dispatch(setLenovoSoft({ word: '', pageKey, data: {} }));
      }
    },
    [value],
  );

  const handleKeyDown = useCallback(() => {}, [value]);

  const handleSoft = useCallback(
    soft => {
      const find = checkSofts.find(item => {
        return item.name === soft.name;
      });
      if (!find) {
        let softArr = [...checkSofts, soft];
        if (softArr.length > 5) {
          Toast.error({ content: '您至多可关联5个软件。' });
        }
        setCheckSofts(softArr.slice(0, 5));
      }
      setValue('');
      dispatch(setLenovoSoft({ word: '', data: {} }));
    },
    [checkSofts],
  );

  const handleSoftClose = useCallback(
    soft => {
      let checkSoftsNew = checkSofts.filter(item => {
        return item.name !== soft.name;
      });
      setCheckSofts(checkSoftsNew);
    },
    [checkSofts],
  );

  return (
    <div className={styles.checksoft}>
      <input
        className={styles.input}
        type="text"
        value={value}
        placeholder={'输入关联软件，获得更多曝光'}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {lenovoSoft &&
        lenovoSoft.data &&
        lenovoSoft.data.length > 0 &&
        lenovoSoft.pageKey === pageKey && (
          <div className={styles.lenovosofts}>
            <div className={styles.lenovosofts_box}>
              {lenovoSoft.data.map((item, i) => (
                <div
                  className={styles.lenovosofts_item}
                  key={i}
                  onClick={() => {
                    handleSoft(item);
                  }}
                >
                  {item.name}
                </div>
              ))}
              <div
                className={styles.lenovosofts_item_}
                onClick={() => {
                  handleSoft({ name: value.slice(0, 15), softId: '' });
                }}
              >
                添加：{value.slice(0, 15)}
              </div>
            </div>
          </div>
        )}

      <div className={styles.checksofts}>
        {checkSoftList &&
          checkSoftList.length > 0 &&
          checkSoftList.map((item, i) => (
            <div className={styles.checksofts_item} key={i}>
              <span className={styles.checksofts_item_text}>{item.name}</span>
              <span
                className={styles.checksofts_item_close}
                onClick={() => {
                  handleSoftClose(item);
                }}
              ></span>
            </div>
          ))}
      </div>
    </div>
  );
};
